<template>
  <modal transition="pop-out" name="update-supplied-good-modal" :width="500" :height="450">
    <div class="w-full">
      <el-form :model="updateForm" class="rounded px-8 pt-6 pb-8 mb-4" :rules="rules" ref="updateForm">
        <el-row>
          <el-col :xs="24">
            <el-form-item prop="name" class="mb-4">
              <label class="text-sm block">Name</label>
              <el-input v-model="updateForm.name" class="w-full" type="text"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="quantity" class="mb-4">
              <label class="text-sm block">Quantity</label>
              <el-input v-model="updateForm.quantity" class="w-full" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="item_id">
              <label class="text-sm block">Item:</label>
              <el-select class="w-full" v-model="updateForm.item_id" filterable placeholder="Link this to an item?">
                <el-option
                  v-for="item in items"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24">
            <el-form-item prop="comment">
              <label class="text-sm block">Comment:</label>
              <el-input class="w-full" type="textarea" :rows="2" v-model="updateForm.comment"
                        placeholder="Do you have any comment regarding this good"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" :updating="updating" @click="submit('updateForm')">Update</el-button>
          <el-button @click="$modal.hide('update-supplied-good-modal')" type="info" plain>Close</el-button>
        </el-form-item>
      </el-form>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'NewSuppliedGoodForm',
  data() {
    return {
      updating: false,
      rules: this.$store.state.InventoryModule.Supplies.supplied_good_form_validation,
    };
  },
  computed: {
    updateForm() {
      return this.$store.state.InventoryModule.Supplies.supplied_good;
    },
    items() {
      return this.$store.state.InventoryModule.Products.products;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('InventoryModule/Products/fetchAllProducts', { page: this.page, limit: this.limit });
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
  methods: {
    async submit(updateForm) {
      this.$refs[updateForm].validate(async (valid) => {
        const formData = {
          supply_id: this.$route.params.id,
          name: this.updateForm.name,
          quantity: this.updateForm.quantity,
          comment: this.updateForm.comment,
          item_id: this.updateForm.item_id,
        };
        if (valid) {
          try {
            this.updating = true;
            await this.$store.dispatch('InventoryModule/Supplies/updateSuppliedGood', {
              suppliedGoodId: this.updateForm.id, suppliedGood: formData,
            });
            this.$modal.hide('update-supplied-good-modal');
            this.$notify.success({
              title: 'Success',
              message: 'Supplied good was successfully updated.',
            });
            this.$refs[updateForm].resetFields();
          } catch (e) {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong',
            });
          }
          this.updating = false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
